/* 平台下单 */
<template>
  <div id="lineForm">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" label-position="left"
      :disabled="view == 'read' || (lineId && !isUpdate)">

      <el-form-item label="机构名称" prop="organizationId">
        <el-select v-model="form.organizationId" :disabled="lineId != null" filterable>
          <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>

      <div class="flex" style="justify-content: space-between;">
        <el-form-item label="出发地" prop="startStationName">
          <el-input v-model="form.startStationName" maxlength="60" placeholder="请输入出发地名称" style="width:200px" />
        </el-form-item>

        <el-form-item label="出发地速记码" prop="startStationCode">
          <el-input v-model="form.startStationCode"
            @input="form.startStationCode = form.startStationCode.replace(/[^\d]/g, '')" maxlength="6"
            placeholder="请输入出发地速记码" style="width:200px" />
        </el-form-item>
      </div>


      <div class="flex" style="justify-content: space-between;">
        <el-form-item label="目的地" prop="endStationName">
          <el-input v-model="form.endStationName" maxlength="60" placeholder="请输入目的地名称" style="width:200px" />
        </el-form-item>

        <el-form-item label="目的地速记码" prop="endStationCode">
          <el-input v-model="form.endStationCode" @input="form.endStationCode = form.endStationCode.replace(/[^\d]/g, '')"
            maxlength="6" placeholder="请输入目的地速记码" style="width:200px" />
        </el-form-item>
      </div>

      <el-form-item v-if="view == 'write'" label="上车站点" prop="startStations" class="linefeed" label-width="100%">
        <div class="stations">
          <el-tag v-for="(station, index) in startStations" :key="index" size="medium" :closable="view == 'write'"
            @close="deleteStation(1, index)">
            {{ station.stationName }}
          </el-tag>
        </div>
        <el-button v-if="startStations.length < 10" type="text" size="medium" @click="addStation(1)">
          <i class="el-icon-circle-plus-outline"></i>
          添加站点
        </el-button>
      </el-form-item>

      <el-form-item v-if="view == 'write'" label="下车站点" prop="endStations" class="linefeed" label-width="100%">
        <div class="stations">
          <el-tag v-for="(station, index) in endStations" :key="index" size="medium" :closable="view == 'write'"
            @close="deleteStation(2, index)">
            {{ station.stationName }}
          </el-tag>
        </div>
        <el-button v-if="endStations.length < 10" type="text" size="medium" @click="addStation(2)">
          <i class="el-icon-circle-plus-outline"></i>
          添加站点
        </el-button>
      </el-form-item>

      <el-form-item v-if="!lineId" prop="isReturn">
        <div slot="label" class="redcheck">往返线路</div>
        <el-switch v-model="form.isReturn" :active-value="1" :inactive-value="2" active-color="#13ce66"
          inactive-color="#ccc" />
      </el-form-item>

      <div class="redcheck" style="height: 28px;">票价</div>
      <el-table border :data="form.railFee">
        <el-table-column prop="startRailName" label="上车站点"></el-table-column>
        <el-table-column prop="endRailName" label="下车站点"></el-table-column>
        <el-table-column prop="fee" label="票价(元)" width="100px" v-slot="{ row, $index }">
          <el-form-item :prop="'railFee.' + $index + '.fee'" :rules="[{ required: true, validator: validatorFee }]"
            class="linefeed" label-width="100%" style="margin-bottom: 0;">
            <el-input v-model="row.fee"
              @input="row.fee = row.fee.replace(/^0/g, '').replace(/^[1-9][0-9]{3,}/g, '999').replace(/(\d\d{0,2}\.?\d{0,2})?.*/g, '$1')" />
          </el-form-item>

        </el-table-column>
      </el-table>

    </el-form>

    <div style="padding:20px 0;text-align: right;">
      <template v-if="view == 'write'">
        <el-button @click="closeFn">取消</el-button>
        <el-button type="primary" :loading="loading" @click="saveClick">完成</el-button>
      </template>
      <template v-else-if="isUpdate">
        <el-button @click="closeFn">关闭</el-button>
        <el-button type="primary" @click="editClick">编辑</el-button>
      </template>
      <template v-else>
        <div class="flex" style="width: 100%;justify-content: space-between;">
          <div>
            <i class="el-icon-warning util-remark" style="font-size: 15px; padding-right: 6px"></i>
            <span class="util-remark">线路有未完成的订单，无法编辑</span>
          </div>
          <el-button @click="closeFn">关闭</el-button>
        </div>
      </template>
    </div>

    <el-dialog class="orderFormMap" :visible.sync="mapVisible" append-to-body title="站点选择" width="500px"
      :before-close="closeMap" :close-on-click-modal="false">
      <div class="map-search">
        <choose-address v-if="mapVisible" :value.sync="keyword" placeholder="在地图上搜索位置" :citycode="cityAdcode"
          @clickRowFn="clickAddressFn"></choose-address>
      </div>
      <div id="line-form-map"></div>
      <div style="margin-top:30px; text-align: center;">
        <el-button type="primary" style="width:50%" :disabled="!mapAddress.adCode" @click="saveMap">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "lineForm",
  props: {
    lineId: Number,
    visible: Boolean
  },
  data() {
    return {
      view: 'write',
      isUpdate: true,
      mapCtx: null,
      mapVisible: false,
      mapType: 1,
      mapAddress: {},
      mark: null,
      keyword: null,
      cityAdcode: null,
      loading: false,
      form: {},
      rules: {
        startStationName: [{ required: true, message: "请输入出发地名称", trigger: ["change"] }],
        endStationName: [{ required: true, message: "请输入目的地名称", trigger: ["change"] }],
        // startStationCode: [{ required: true, message: "请输入速记码", trigger: ["change"] }],
        // endStationCode: [{ required: true, message: "请输入速记码", trigger: ["change"] }],
        startStations: [{
          validator: (rule, value, callback) => {
            if (this.startStations.length == 0) {
              callback(new Error("请添加上车站点"));
            } else {
              callback();
            }
          }, required: true, trigger: ["change"]
        }],
        endStations: [{
          validator: (rule, value, callback) => {
            if (this.endStations.length == 0) {
              callback(new Error("请添加下车站点"));
            } else {
              callback();
            }
          }, required: true, trigger: ["change"]
        }],
        organizationId: [{ required: true, message: "请选择机构名称" }],
      },

      startStations: [],
      endStations: []
    };
  },
  watch: {
    lineId: {
      handler(val) {
        if (val) {
          this.getLineForm();
          this.getIsUpdate();
          this.view = "read";
        }
      },
      deep: true,
      immediate: true
    },
    visible(val) {
      if (val) {
        this.$refs.form.clearValidate();
        if (this.organizations.length > 0) {
          this.$set(this.form, "organizationId", this.organizations[0].id);
        }
      } else {
        this.view = 'write'
        this.form = {};
        this.startStations = [];
        this.endStations = [];
        // this.railFee = [];
      }
    },
    mapVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.initMap();
        })
      }
    }
  },
  async created() {
    await this.mixinOrganizations();
    if (!this.lineId) {
      this.$set(this.form, "organizationId", this.organizations[0].id);
    }
  },
  methods: {
    validatorFee(rule, value, callback) {
      let index = rule.field.split('.')[1]
      if (!this.form.railFee[index].fee) {
        callback(new Error('请输入票价'));
      } else {
        callback();
      }
    },
    /* 获取线路信息 */
    async getLineForm() {
      let url = "/api/v1/manage/line/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data.stationVoList) {
        data.data.railFee = data.data.stationRailFee;
        this.form = data.data;
        this.startStations = data.data.stationVoList[0].stationRail;
        this.endStations = data.data.stationVoList[1].stationRail;
      }
    },

    /* 查询线路是否可以编辑 */
    async getIsUpdate() {
      let url = "/api/v1/manage/line/station/isUpdate/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.isUpdate = data.data;
      }
    },

    /* 初始化地图 */
    initMap() {
      this.mapCtx = new AMap.Map("line-form-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        center: new AMap.LngLat(104.065861, 30.657401),
        zoom: 12,
        doubleClickZoom: false
      });

      // 鼠标双击事件
      this.mapCtx.on("dblclick", async (e) => {
        this.handleDouble(e.lnglat);
      });

      this.cityAdcode = this.mapCtx.getAdcode();

      // 编辑回显
      this.$nextTick(() => {
        if (this.mapAddress.stationRail) {
          this.keyword = this.mapAddress.stationRail[0].stationName;
          let position = new AMap.LngLat(this.mapAddress.stationRail[0].longitude, this.mapAddress.stationRail[0].latitude);
          this.mark = new AMap.Marker({
            map: this.mapCtx,
            position: position,
            // anchor: "bottom-center",
            animation: "AMAP_ANIMATION_DROP",
            icon: [require("@/assets/img/markerBegin.png"), require("@/assets/img/markerEnd.png")][this.mapType - 1],
            offset: new AMap.Pixel(-2, 0),
          });
          let content = `<div class="markerLabel ${this.mapType == 1 ? "startFC" : "endFC"}">${this.keyword}</div>`;
          this.mark.setLabel({
            content: content,
            direction: "top",
            offset: new AMap.Pixel(0, -6),
          });
          this.mapCtx.panTo(position);
        }
      })
    },

    /* 处理双击地图的回调位置 */
    async handleDouble(lnglat) {
      let resCity = await this.$AMap.AMapReGeo(lnglat);

      if (resCity) {
        this.mapCtx.clearMap();
        let pois = resCity.regeocode.pois;
        pois.sort((a, b) => a.distance - b.distance);
        let stationName = pois && pois[0] && pois[0].name ? pois[0].name : resCity.regeocode.formatted_address;

        let position = new AMap.LngLat(lnglat.lng, lnglat.lat);
        console.log(position);
        this.mark = new AMap.Marker({
          map: this.mapCtx,
          position: position,
          // anchor: "bottom-center",
          animation: "AMAP_ANIMATION_DROP",
          icon: [require("@/assets/img/markerBegin.png"), require("@/assets/img/markerEnd.png")][this.mapType - 1],
          offset: new AMap.Pixel(-2, 0),
        });
        let content = `<div class="markerLabel ${this.mapType == 1 ? "startFC" : "endFC"}">${stationName}</div>`;
        this.mark.setLabel({
          content,
          direction: "top",
          offset: new AMap.Pixel(0, -6),
        });
        this.mapCtx.panTo(position);


        let stationAddress = pois && pois[0] && pois[0].address ? pois[0].address : resCity.regeocode.formatted_address;
        let addressComponent = resCity.regeocode.addressComponent;
        let mapAddress = {
          stationName,
          stationAddress,
          area: addressComponent.district,
          adCode: addressComponent.adcode,
          city: addressComponent.city,
          cityCode: addressComponent.citycode,
          province: addressComponent.province,
          longitude: lnglat.lng,
          latitude: lnglat.lat,
          railNo: this[this.mapType == 1 ? 'startStations' : 'endStations'].length + 1,
          stationType: 1
        }

        this.keyword = stationName;
        this.mapAddress = mapAddress;
      }
    },

    /* 选中地址 */
    clickAddressFn(res) {
      this.mapCtx.clearMap();
      let position = new AMap.LngLat(res.location.lng, res.location.lat);
      this.mark = new AMap.Marker({
        map: this.mapCtx,
        position: position,
        // anchor: "bottom-center",
        animation: "AMAP_ANIMATION_DROP",
        icon: [require("@/assets/img/markerBegin.png"), require("@/assets/img/markerEnd.png")][this.mapType - 1],
        offset: new AMap.Pixel(-2, 0),
      });
      let content = `<div class="markerLabel ${this.mapType == 1 ? "startFC" : "endFC"}">${res.name}</div>`;
      this.mark.setLabel({
        content,
        direction: "top",
        offset: new AMap.Pixel(0, -6),
      });
      this.mapCtx.panTo(position);

      this.getAddressMsg(res);
    },

    /* 获取选中地址的详细信息 */
    async getAddressMsg(res) {
      let resCity = await this.$AMap.AMapReGeo(res.location);

      if (resCity) {
        let addressComponent = resCity.regeocode.addressComponent;
        let mapAddress = {
          stationName: res.name,
          stationAddress: res.address,
          area: addressComponent.district,
          adCode: addressComponent.adcode,
          city: addressComponent.city,
          cityCode: addressComponent.citycode,
          province: addressComponent.province,
          longitude: res.location.lng,
          latitude: res.location.lat,
          railNo: this[this.mapType == 1 ? 'startStations' : 'endStations'].length + 1,
          stationType: 1
        }

        this.mapAddress = mapAddress;
      }
    },

    /* 新增地址 */
    addStation(mapType) {
      this.mapVisible = true;
      this.mapType = mapType;
      this.mapAddress = {};
    },

    /* 删除地址 */
    deleteStation(mapType, index) {
      this[mapType == 1 ? 'startStations' : 'endStations'].splice(index, 1);
      this[mapType == 1 ? 'startStations' : 'endStations'].map((item, index) => {
        item.railNo = index + 1
      })
      this.railFeeComputed();
    },

    /* 关闭地图 */
    closeMap() {
      this.mapCtx.clearMap();
      this.mapVisible = false;
      this.mapAddress = {};
      this.mark = null;
    },

    /* 确定地点 */
    saveMap() {
      this[this.mapType == 1 ? 'startStations' : 'endStations'].push(this.mapAddress);
      this.mapVisible = false;
      this.keyword = null;
      this.$refs.form.validateField(this.mapType == 1 ? "startStations" : "endStations");
      this.railFeeComputed();
    },

    /* 生成站-站价格表 */
    railFeeComputed() {
      // 匹配历史价格
      let getOldFee = (startRailNo, endRailNo, startRailName, endRailName) => {
        let fee = null;
        map: for (let item of this.form.railFee) {
          if (item.startRailNo == startRailNo && item.endRailNo == endRailNo && item.startRailName == startRailName && item.endRailName == endRailName) {
            fee = item.fee;
            break map;
          }
        }
        return fee;
      };

      // 起点终点交叉处理函数
      let crossFn = (...arrs) => {
        // 单程交叉 arr1>起点列表  arr2>终点列表
        let oneWay = arrs.reduce((arr1, arr2) => {
          return arr1.flatMap((e) => {
            return arr2.map((e2) => {
              return {
                startStationType: 1,
                endStationType: 1,
                startRailName: e.stationName,
                endRailName: e2.stationName,
                startRailNo: e.railNo,
                endRailNo: e2.railNo,
                fee: getOldFee(e.railNo, e2.railNo, e.stationName, e2.stationName)
              };
            });
          });
        });
        return oneWay;
      };
      this.form.railFee = crossFn(this.startStations, this.endStations);
    },

    /* 取消 */
    closeFn(event) {
      this.$emit('closeFn', event)
    },

    /* 编辑 */
    async editClick() {
      await this.getIsUpdate();
      if (this.isUpdate) {
        this.view = 'write'
      } else {
        this.$message.warning("线路有未完成订单，无法编辑");
      }
    },

    /* 保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning("请完善表单数据");
        }
      });
    },

    async postFn() {
      let url = "/api/v1/manage/line";

      let [start, end] = [this.startStations[0], this.endStations[0]];
      let station = [
        {
          id: this.lineId ? this.form.stationVoList[0].id : null,
          type: 1,
          stationType: this.startStations.length == 1 ? 1 : 2,
          area: start.area || "",
          adCode: start.adCode || "",
          city: start.city || "",
          cityCode: start.cityCode || "",
          province: start.province || "",
          stationRail: this.startStations,
        },
        {
          id: this.lineId ? this.form.stationVoList[1].id : null,
          type: 2,
          stationType: this.endStations.length == 1 ? 1 : 2,
          area: end.area || "",
          adCode: end.adCode || "",
          city: end.city || "",
          cityCode: end.cityCode || "",
          province: end.province || "",
          stationRail: this.endStations
        },
      ];

      let params = {
        ...this.form,
        station: JSON.stringify(station),
        railFee: JSON.stringify(this.form.railFee),
        channelType: 2
      };

      this.loading = true;
      let data = await this.$axios[this.lineId ? 'put' : 'post'](url, params);
      this.loading = false;
      if (data && data.code === 1) {
        this.$message.success("保存成功");
        this.closeFn();
      }
    },
  },
};
</script>

<style lang="less" scoped>
#lineForm {
  width: 100%;

  /deep/ .el-form-item__label,
  .el-button--text {
    font-size: 14px !important;
  }

  .linefeed /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .stations {
    line-height: 35px;

    .el-tag {
      margin-right: 10px;
    }
  }

}

.map-search {
  #chooseAddress {
    width: 100%;
    margin-right: 0;

    /deep/ .map-show {
      left: 0;
    }

    /deep/ .close-btn {
      top: 4px;
    }
  }

}

#line-form-map {
  width: 100%;
  height: 400px;
  position: relative;
  z-index: 0;

  /deep/ .markerLabel {
    padding: 1rem 1.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffffff;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

    &.start {
      background-color: #0289ffbb;
    }

    &.startFC {
      background-color: #0289ff;
    }

    &.end {
      background-color: #228b22bb;
    }

    &.endFC {
      background-color: #228b22;
    }
  }
}
</style>
